import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Button from "../../common/Button";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import documentHelperUtil from "../../../components/common/DocumentHelperUtil";

const GemeentePDFForm = (props) => {
    const {
        disabled,
        color,
        documents,
        isPollingDocument,
        onGeneratePDF,
        onGaTerug,
        fileDownloadUrl
    } = props;

    function handleOnGenereerPdf(pdfPollingProps) {
        return function () {
            onGeneratePDF(pdfPollingProps);
        };
    }

    const componentName = "PDF_gemeente";

    let pdfDocumentenProps =
        documentHelperUtil.getDocumentComponentProps(
            "PDF van de tocht",
            componentName,
            fileDownloadUrl,
            documents,
            true,
            null,
            null,
            null,
            false,
            null,
            null,
            color,
            6
        );

    const maxPollCount = 5;
    const isPollingDocumentValue = isPollingDocument(pdfDocumentenProps.componentName, maxPollCount);
    const pdfPollingProps = documentHelperUtil.getPollingProps(maxPollCount, 1, isPollingDocumentValue, componentName);

    return (
        <Form name="Samenvatting"
            headerVisible={false}
            isNotRequired
            leftButtonLabel="Terug naar overzicht"
            onLeftButtonClick={onGaTerug}
            color={color}>
            <div className={"o-col-12 c-fiche-wrap"}>
                <DownloadUploadFiles {...pdfDocumentenProps} />
                <div className={"o-col-6"}>
                    <div className="c-fiche-wrap">
                        <div className="">
                            <Button className={"o-col-12"} onClick={handleOnGenereerPdf(pdfPollingProps)} disabled={isPollingDocumentValue || disabled} text={"Genereer PDF"} />
                            {isPollingDocumentValue ?
                                <div>even geduld a.u.b.</div>
                                : null}
                        </div>
                    </div>
                </div>
            </div>
        </Form>);
};

GemeentePDFForm.propTypes = {
    disabled: PropTypes.bool,
    color: PropTypes.string,
    documents: PropTypes.array,
    isPollingDocument: PropTypes.bool,
    onGeneratePDF: PropTypes.func.isRequired,
    onGaTerug: PropTypes.func.isRequired,
    fileDownloadUrl: PropTypes.string.isRequired
};

export default GemeentePDFForm;